import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";
import XCard from "./XCard";
import { useTranslation } from "react-i18next";

import "../../styles/app/XSection.css";
import "swiper/css";
import "swiper/css/pagination";

const XSection: React.FC = () => {
  const { t } = useTranslation();

  const opinions = [
    {
      user: "Noticias tecnológicas hoy",
      title: t("xSection.opinions.0.title"),
      desc: t("xSection.opinions.0.desc"),
    },
    {
      user: "El economista hispano",
      title: t("xSection.opinions.1.title"),
      desc: t("xSection.opinions.1.desc"),
    },
    {
      user: "Startup LATAM",
      title: t("xSection.opinions.2.title"),
      desc: t("xSection.opinions.2.desc"),
    },
    {
      user: "Macroventas",
      title: t("xSection.opinions.3.title"),
      desc: t("xSection.opinions.3.desc"),
    },
    {
      user: "Zenup",
      title: t("xSection.opinions.4.title"),
      desc: t("xSection.opinions.4.desc"),
    },
  ];

  return (
    <>
      <section className="x-section">
        <div className="x-container">
          <Swiper
            modules={[Pagination]}
            spaceBetween={30}
            slidesPerView={3}
            loop={true}
            breakpoints={{
              0: {
                slidesPerView: 1,
              },
              768: {
                slidesPerView: 2,
              },
              1280: {
                slidesPerView: 3,
              },
            }}
            pagination={{
              clickable: true,
            }}
          >
            {/* Slides */}
            {opinions.map((opinion, index) => (
              <SwiperSlide key={index}>
                <XCard {...opinion} />
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </section>
    </>
  );
};

export default XSection;
